export const CustomBeeScorecardSetting = 'CustomBEEScorecardSettings/';

export const GetCustomFieldNames =  CustomBeeScorecardSetting + 'GetCustomFieldSettings'
export const SaveCustomFieldNames =  CustomBeeScorecardSetting + 'SaveCustomFieldSettings'
